export default class roomPlayersChange{

    private room_id: string;
    private modBookCalendar: any;
    private modRoomGames: any;
    private el_time_slot: string;
    private playersControl: any;
    private games_container_selector: string = '#games-container';

    /**
     * The constructor receives dependencies from roomInit.
     */
    constructor(options: any) {

        this.room_id = options.roomId;
        this.modBookCalendar = options.calendarModule;
        this.modRoomGames = options.gamesModule;
        this.el_time_slot = options.timeSlotSelector;
        this.playersControl = options.playersControl;

    }

    /**
     * Sets up the 'change' event listener on the players' TomSelect control.
     */
    initialize(){

        if(!this.playersControl){

            console.error('Players TomSelect control was not provided to the handler.');
            return;

        }

        this.playersControl.on('change', this._handlePlayersChange.bind(this));

    }

    /**
     * This async function is triggered when the players selection changes.
     * @param {string} newPlayersValue - The new value selected (comes as a string).
     * @private
     */
    private async _handlePlayersChange(newPlayersValue: string) {

        // Ignore if the selection is cleared or invalid
        if(!newPlayersValue) return;

        // The value from TomSelect is a string, convert it to a number for our API call.
        const playersAsNumber = parseInt(newPlayersValue, 10);
        if(isNaN(playersAsNumber)) return;

        try{

            // Get other necessary values from the page
            const val_date = this.modBookCalendar.getDate('y-mm-dd');
            const timeSlotElement: any = document.querySelector(this.el_time_slot);
            const timeSlotValue = timeSlotElement ? timeSlotElement.tomselect.getValue() : null;

            if(!val_date || !timeSlotValue){

                throw new Error('Could not retrieve current date or time slot.');

            }

            // 1. Show preloader for the games section
            this.modRoomGames.showPreloader(this.games_container_selector);

            // 2. Reload the games with the new players count
            const response = await this.modRoomGames.get(this.room_id, val_date, timeSlotValue, playersAsNumber);

            // 3. Render the new games list
            this.modRoomGames.renderGames(response.data.data, this.games_container_selector);

        }catch (error){

            console.error('Failed to update games after players change:', error);
            this.modRoomGames.showError(this.games_container_selector, 'Errore durante l\'aggiornamento dei giochi.');

        }

    }

}